
const CareRecipientNameType = Symbol();

// 名前の最大長
export const CareRecipientNameMaxLength = 60;

export class CareRecipientName {
    [CareRecipientNameType]: any;
    readonly value: string;

    private constructor(careRecipientName: string) {
        this.value = careRecipientName;
    }

    static fromString(careRecipientName: string): CareRecipientName {
        return new CareRecipientName(careRecipientName);
    }

    // 氏名の最大長チェック
    isValidLength(): boolean {
        return !(this.value.length > CareRecipientNameMaxLength);
    }
}
